<template>
  <div v-if="loading">
    <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
  </div>
  <div v-else>
    <template>
      <div class="sa-blue-text sa-text-clr">Change Password</div>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }" tag="div" class="sa-row sa-mt20 sa-lne">
        <ValidationProvider ref="op_field" name="current password" rules="required|min:6" v-slot="{ errors }" tag="div" class="sa-col-xs12 sa-col-sm12 sa-col-md3 sa-col-lg3 sa-mb20">
          <div class="sa-form-group sa-mb0">
            <label>Current Password <span class="sa-red-text">*</span></label>
              <input
                type="password"
                v-model="changePass.oldPass" id="currentPassword"
                class="sa-line-input"
                @input="changePass.oldPass = changePass.oldPass.replace(/\s/g, '')" name="current password"
              />
          </div>
              <span class="sa-val-err">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider ref="np_field" name="new password" rules="required|min:6" v-slot="{ errors }" tag="div" class="sa-col-xs12 sa-col-sm12 sa-col-md3 sa-col-lg3 sa-mb20">
          <div class="sa-form-group sa-mb0">
            <label>New Password <span class="sa-red-text">*</span></label>
              <input
                type="password"
                v-model="changePass.newPass" name="new password" id="newPassword"
                class="sa-line-input"
                @input="changePass.newPass = changePass.newPass.replace(/\s/g, '')"
              />
          </div>
              <span class="sa-val-err">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider
              ref = "cp_field"
              name="confirm password"
              rules="required|min:6|confirmNewPass:@new password"
              v-slot="{ errors }" tag="div" class="sa-col-xs12 sa-col-sm12 sa-col-md3 sa-col-lg3 sa-mb20">
          <div class="sa-form-group sa-mb0">
            <label>Confirm New Password <span class="sa-red-text">*</span></label>
              <input
                type="password"
                v-model="changePass.confirmNewPass" name="confirm password" id="confirmPassword"
                class="sa-line-input"
                @input="changePass.confirmNewPass = changePass.confirmNewPass.replace(/\s/g, '')"
              />
            </div>
              <span class="sa-val-err">{{ errors[0] }}</span>
          </ValidationProvider>
        <div class="sa-col-xs12 sa-col-sm12 sa-col-md3 sa-col-lg3">
          <button @click="handleSubmit(changePassword)" class="sa-btn sa-btn-primary sa-blue-btn sa-btn-large sa-btn-block sa-mt10">
            Change Password
          </button>
        </div>
      </ValidationObserver>
      <div class="sa-dialog-white" v-if="pwd_loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>      
      <div
        v-if="userInfo.eid == 'HSP1' || userInfo.eid == 'HSP0'"
        class="sa-blue-text sa-text-clr sa-mt20"
      >Bank Details</div>
      <div
        v-if="(userInfo.eid == 'HSP1' || userInfo.eid == 'HSP0') && !showBankEditForm"
        class="sa-card sa-mt30 sa-card-dgray sa-card-noshadow"
      >
        <div class="sa-row sa-accnt">
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <label>Name as mentioned in bank</label>
            {{bankdetails.unme}}
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <label>Bank Name</label>
            {{bankdetails.bank_nm}}
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <label>I BAN number</label>
            {{bankdetails.iban}}
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <label>Account number</label>
            {{bankdetails.ac_no}}
          </div>
        </div>
        <button @click="showBankEditForm = true" class="sa-btn sa-bank-edit-btn">
              <i class="icon-edit3 "></i> <span class="sa-text-underline">Edit</span>
            </button>
      </div>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <div class="sa-row sa-mt20 sa-bnk-text" v-if="showBankEditForm">
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <div class="sa-form-group">
              <label>Name as mentioned in bank  <span class="sa-red-text">*</span></label>
              <ValidationProvider
                name="name as mentioned in bank"
                rules="required|regex:^[^\s]+(\s+[^\s]+)*$"
                v-slot="{ errors }"
              >
                <input type="text" class="sa-line-input" v-model="bankdetails.unme" name="name as mentioned in bank" id="mentionedBank" />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <div class="sa-form-group">
              <label>Bank Name  <span class="sa-red-text">*</span></label>
              <ValidationProvider
                name="bank name"
                rules="required|alpha|regex:^[^\s]+(\s+[^\s]+)*$"
                v-slot="{ errors }"
              >
                <input type="text" class="sa-line-input" v-model="bankdetails.bank_nm" name="bank name" id="bankName"/>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <div class="sa-form-group">
              <label>I BAN number  <span class="sa-red-text">*</span></label>
              <ValidationProvider
                name="I BAN number"
                rules="required|regex:^[^\s]+(\s+[^\s]+)*$"
                v-slot="{ errors }"
              >
                <input type="text" class="sa-line-input" v-model="bankdetails.iban" id="ibanNumber"  name="I BAN number" />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg3">
            <div class="sa-form-group">
              <label>Account number  <span class="sa-red-text">*</span></label>
              <ValidationProvider
                name="account number"
                rules="required|numeric|regex:^[^\s]+(\s+[^\s]+)*$"
                v-slot="{ errors }"
              >
                <input type="text" class="sa-line-input" v-model="bankdetails.ac_no"  name="account number" id="accountNumber"/>
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="sa-col-xs12 sa-col-sm9 sa-col-md9 sa-col-lg9"></div>
          <div class="sa-col-xs12 sa-col-sm12 sa-col-md3 sa-col-lg3 sa-text-right sa-mt15">
            <button @click="handleSubmit(addBankdetails)" class="sa-btn sa-btn-primary sa-blue-btn sa-btn-large sa-btn-block">
              Save
            </button>
          </div>
        </div>
      </ValidationObserver>
      
      <div  v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>  
    </template>
  </div>
</template>
<script>
import { pro_url } from "../../../config/endpoints";
import { extend } from "vee-validate";
import { required, min, numeric, alpha, regex } from "vee-validate/dist/rules";
import NoDataFoundVue from '../common/NoDataFound.vue';

extend("required", {
  ...required,
  message: "Provide {_field_}"
});
extend("min", {
  ...min,
  message: "Your password must contain 6 characters"
  // Password should contain a minimum of 6 characters
});

extend("confirmNewPass", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Password confirmation does not match"
});
extend("numeric", {
  ...numeric,
  message: "Please provide a valid {_field_}"
});
extend("alpha", {
  ...alpha,
  message: "Please provide a valid {_field_}"
});
extend("regex", {
  ...regex,
  message: "Spaces not allowed at start or end of the name"
});
export default {
  components: {
      'no-data-found': NoDataFoundVue
  },
  data() {
    return {
      eflag: true,
      showBankEditForm: false,
      pwd_loader: false,
      loader: false,
      loading: false,
      changePass: {
        oldPass: "",
        newPass: "",
        confirmNewPass: ""
      },
      bankdetails: {
        unme: "",
        bank_nm: "",
        iban: "",
        ac_no: "",
        LAST_SETTLEMENT_DATE: "",
        LAST_SETTLEMENT_AMOUNT: "",
        NEXT_SETTLEMENT_DATE: ""
      },
      accountdetails: {},
      userInfo: {}
    };
  },
  methods: {
    changePassword() {
      let _self = this;
      _self.pwd_loader = true;
      let res = _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/changePassword`,
          body: {
            oldpw: _self.changePass.oldPass,
            newpw: _self.changePass.newPass
          }
        })
        .then(response => {
          if (response.status === 1000) {
             _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-success'})
             _self.changePass.oldPass=''
             _self.changePass.newPass=''
             _self.changePass.confirmNewPass=''
            _self.$refs.op_field.reset()
            _self.$refs.np_field.reset()
            _self.$refs.cp_field.reset()
          }
            else {
              _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-danger'})
  
          }
          _self.pwd_loader = false;
        });
    },
    getBankdetails() {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getSettlements`,
          body: {}
        })
        .then(response => {
          if (response && response.status === 1000) {
            _self.bankdetails = response.data;
            _self.loading = false;
          } else if (response && response.status == '2001'){
              _self.$store.dispatch('SET_ALERTMESSAGE', { 'msg': 'Session Expired. Please login again', class: 'sa-a-danger' })
              _self.loading = false;
              _self.$localStorage.remove("token")
              _self.$localStorage.remove("userdata")
              _self.$router.push({ path: '/' })
          } else {
            // _self.$router.push({path:'/404-error'})
            _self.eflag = false;
            _self.loading = false;
          }
        });
    },
    addBankdetails() {
      let _self = this;
      _self.loader = true;
      let res = _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addBankingInfo`,
          body: {
            unme: _self.bankdetails.unme,
            ac_no: _self.bankdetails.ac_no,
            bank_nm: _self.bankdetails.bank_nm,
            iban: _self.bankdetails.iban
          }
        })
        .then(response => {
          if (response.status === 1000) {
            _self.bankdetails.unme = response.data.USERNAME,
            _self.bankdetails.ac_no = response.data.ACCOUNT_NUMBER,
            _self.bankdetails.bank_nm = response.data.BANK_NAME,
            _self.bankdetails.iban = response.data.BANK_CODE
            // _self.getBankdetails();
            _self.showBankEditForm = false;
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success",
            });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch(e => {
         // console.log(e);
        });
    },
    getMultiSlot() {
            let _self = this;
            _self.$store
                .dispatch("httpGet", {
                    uri: `${pro_url}/checkingMultiSlotConfig`,
                    body: {}
                })
                .then(response => {
                    if (response.status === 1000) {
                     this.$emit('multislot', response.multiSlot)
                    }
                })
                .catch(e => {
                    // console.log(e);
                });

        },
  },
  created() {
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
    _self.getBankdetails();
    _self.getMultiSlot();
  }
};
</script>
